/**
 * "Acerca de Faktelio" — Q-04 del QA contra la Sede de la AEAT (aprobado por
 * el propietario el 2026-09-22) y RRSIF art. 13.
 *
 * La FAQ oficial de certificación pide que la declaración responsable de la
 * versión que funciona se consulte "de forma rápida, fácil e intuitiva" desde
 * cualquier acceso al sistema (recomienda "Ayuda" o "Acerca de"), y que todas
 * las versiones sean públicas. Esta pantalla sale en Configuración › Soporte
 * y, sin sesión, en /declaracion-responsable.
 *
 * Los datos vienen de GET /api/v1/sif. Mientras no haya declaración firmada
 * para la versión, se dice tal cual; la emisión está bloqueada por la API
 * (SIF_DECLARATION_MISSING), no por esta pantalla.
 */
import { useEffect, useState } from "react";
import { api, type AcercaDeSif } from "../api/cliente";
import { t } from "../i18n/es";
import { Aviso, Tarjeta } from "../ui/primitivas";

export function PantallaAcercaDe() {
  const [datos, setDatos] = useState<AcercaDeSif | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let vivo = true;
    void api.acercaDe().then((r) => {
      if (!vivo) return;
      if (r.ok) setDatos(r.datos);
      else setError(true);
    });
    return () => {
      vivo = false;
    };
  }, []);

  return (
    <Tarjeta titulo={t.acercaDe.titulo}>
      {error ? <Aviso tono="error">{t.acercaDe.errorCarga}</Aviso> : null}
      {datos === null ? (
        error ? null : <p className="ayuda-neutra">{t.acercaDe.cargando}</p>
      ) : (
        <>
          <dl className="acerca-de">
            <dt>{t.acercaDe.sistema}</dt>
            <dd>
              {datos.sistema} ({datos.idSistema})
            </dd>
            <dt>{t.acercaDe.version}</dt>
            <dd>{datos.version ?? t.acercaDe.sinVersion}</dd>
            <dt>{t.acercaDe.productor}</dt>
            <dd>
              {datos.productor}
              {datos.nifProductor !== null ? ` · NIF ${datos.nifProductor}` : ""}
            </dd>
          </dl>
          <h3>{t.acercaDe.declaracionTitulo}</h3>
          {datos.declaracion !== null ? (
            <p>
              <a href={datos.declaracion.url} target="_blank" rel="noopener noreferrer">
                {t.acercaDe.verDeclaracion(datos.declaracion.version)}
              </a>{" "}
              · {t.acercaDe.firmada(datos.declaracion.signedAt, datos.declaracion.signedPlace)}
            </p>
          ) : (
            <p className="ayuda-neutra">{t.acercaDe.sinDeclaracion}</p>
          )}
          {datos.declaraciones.length > 0 ? (
            <>
              <h3>{t.acercaDe.anterioresTitulo}</h3>
              <ul>
                {datos.declaraciones.map((d) => (
                  <li key={d.version}>
                    <a href={d.url} target="_blank" rel="noopener noreferrer">
                      {t.acercaDe.verDeclaracion(d.version)}
                    </a>{" "}
                    · {t.acercaDe.firmada(d.signedAt, d.signedPlace)}
                  </li>
                ))}
              </ul>
            </>
          ) : null}
        </>
      )}
    </Tarjeta>
  );
}
